<script>
  import Profile from '../components/Profile.svelte';
  import Deck from '../components/Deck.svelte'
  import BoardItem from '../components/BoardItem.svelte'
  import { db, fb } from "../components/firebase";

  import { auth, googleProvider } from '../components/firebase';
  import { authState } from 'rxfire/auth';

  import { Router, Link, Route } from "svelte-routing";

  export let url = "";


  let user;

  const unsubscribe = authState(auth).subscribe(u => user = u);

  function login() {
      auth.signInWithPopup(googleProvider);
      shareSlug = ""
  }

  function loginGuest(){
      auth.signInAnonymously();
  }

  import queryString from "query-string";

  let parsed = {};

  export let shareSlug;
  let shareID;
  // export let boardID = "fZLMl08WvVavox7GOnlj";
  export let boardID;
  export let boards = [];
  let permissions;

  // if (typeof window !== 'undefined') {
  //     parsed = queryString.parse(window.location.search);
  //     if(parsed.share){
  //         if(parsed.share.length > 5){
  //             shareSlug = parsed.share;
  //             const removeQuery = db.collection('boards').where('shareSlug','==',shareSlug);
  //             removeQuery.get().then(function(querySnapshot) {
  //                 querySnapshot.forEach(function(doc) {
  //                     console.log(doc.data())
  //                     console.log(shareSlug)
  //                     shareID = doc.data().boardID;
  //                     boardID = shareID
  //                     permissions = "false";
  //                 });
  //             });
  //         }
  //     }
  //     // console.log(parsed)
  // }
  // console.log(shareID);

  $: if (shareSlug != "" && shareSlug != undefined) {       // make it react to changes (in the parent)
      console.log("slug detected")
      const removeQuery = db.collection('boards').where('shareSlug','==',shareSlug);
      removeQuery.get().then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              console.log(doc.data())
              console.log(shareSlug)
              shareID = doc.data().boardID;
              boardID = shareID
              permissions = "false";
          });
      });
  }else{
      console.log("no slug")
      shareID = "";
      boardID = ""
      // window.history.replaceState({}, '','/');
  }; 

//   function changeBoard(event){
//       const { selected } = event.detail;
//       // console.log(selected)
//       boardID=selected;
//       boardID = boardID;
//       // console.log(boardID)
//   }

//   function setBoards(event){
//       // console.log("==================")
//       const { boardList } = event.detail
//       // alert(event.detail.boardList)
//       // console.log(boardList)
//       boards = boardList;
//       // console.log(boards)
//   }

//   // Variables
//   let page
//   let params
//   let deckTitle = ""

//     // Create a deck
// async function createDeck() {
//   // const firestore = firebase.firestore();
//   if(deckTitle != ""){
//           const data = {};
//           const doc = await db.collection('decks').add(data);
//           console.log('Deck created', {
//               id: doc.id,
//               data: data
//           });

//           const d2 = {
//               boardID: doc.id,
//               title: deckTitle,
//               uid: user.uid
//           }
//           // await db.collection('boards').add(d2)
//           await db.collection('boards').doc(doc.id).set(d2);
//           boardID = doc.id;
//           // boardID = selected
//           // changeBoard();
//           deckTitle=""
//           return doc.id;
//       }
//       else{
//           alert("Please add a title");
//       }
// }

//   async function deleteDeck(event){
//       // await db.collection('boards').add(d2)
//       const id = event.detail.id
//       boardID=""
//       console.log("to remove: " + id);

//       var removeQuery = db.collection('boards').where('boardID','==',id);
//       removeQuery.get().then(function(querySnapshot) {
//       querySnapshot.forEach(function(doc) {
//           doc.ref.delete().then(() => {
//               console.log("Document successfully deleted!");
//           }).catch((error) => {
//               console.error("Error removing document: ", error);
//           });
//       });
//       });
//   }

//   let shareSlugText;
//   $:  if (boardID != "" && boardID != undefined) {       // make it react to changes (in the parent)
//           const docRef = db.collection("boards").doc(boardID);

//           docRef.get().then((doc) => {
//               if (doc.exists) {
//                   // console.log("Document data:", doc.data());
//                   shareSlugText = doc.data().shareSlugText;
//               } else {
//                   // doc.data() will be undefined in this case
//                   console.log("No such document!");
//               }
//           }).catch((error) => {
//               console.log("Error getting document:", error);
//           });
//       }else{

//       }; 





</script>


<section>


  <div class="profile-header">
      <div class="profile-card flex">
          <div class="details">
              <svg class="logo" class:small="{boardID != '' && boardID != undefined}" viewBox="0 0 721 150" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>Group</title>
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Artboard" transform="translate(-68.000000, -115.000000)">
                          <rect id="Rectangle" fill="#262728" x="33" y="30" width="1429" height="318" rx="8"></rect>
                          <g id="Group" transform="translate(68.058582, 115.509369)" fill="#EFF0F2" fill-rule="nonzero">
                              <path d="M58.3734398,145.490631 C88.692191,145.490631 106.903129,130.232818 106.903129,105.229692 C106.903129,86.7234409 94.1062537,73.0406279 74.9109405,71.0718778 L74.9109405,69.3984403 C88.889066,67.0359402 99.815629,53.7468771 99.815629,38.882814 C99.815629,17.0296882 83.7703158,3.44531264 57.0937523,3.44531264 L-6.82121026e-13,3.44531264 L-6.82121026e-13,145.490631 L58.3734398,145.490631 Z M48.2343769,63.5906275 L22.0500009,63.5906275 L22.0500009,22.1484384 L51.9750021,22.1484384 C68.3156277,22.1484384 77.8640656,29.8265637 77.8640656,42.9187517 C77.8640656,56.4046897 67.7250027,63.5906275 48.2343769,63.5906275 Z M53.9437521,126.787505 L22.0500009,126.787505 L22.0500009,81.0140657 L52.6640646,81.0140657 C73.4343779,81.0140657 84.3609409,88.7906285 84.3609409,103.654692 C84.3609409,118.71563 73.8281279,126.787505 53.9437521,126.787505 Z M146.104694,145.490631 L146.104694,91.3500036 L177.210945,91.3500036 L206.151571,145.490631 L231.646885,145.490631 L199.753133,87.707816 C217.078134,81.8015658 227.315634,66.2484401 227.315634,47.1515644 C227.315634,20.4750008 208.907821,3.44531264 180.262508,3.44531264 L124.054693,3.44531264 L124.054693,145.490631 L146.104694,145.490631 Z M177.80157,72.5484404 L146.104694,72.5484404 L146.104694,22.8375009 L177.210945,22.8375009 C194.240633,22.8375009 204.675009,32.1890638 204.675009,47.6437519 C204.675009,63.49219 194.831258,72.5484404 177.80157,72.5484404 Z M269.667199,145.490631 L269.667199,3.44531264 L247.617198,3.44531264 L247.617198,145.490631 L269.667199,145.490631 Z M352.37814,148.935943 C384.075017,148.935943 407.404705,130.232818 411.342205,102.178129 L389.390642,102.178129 C385.453142,118.223442 371.179704,128.362505 352.37814,128.362505 C326.784389,128.362505 310.837514,107.592192 310.837514,74.5171905 C310.837514,41.3437516 326.784389,20.5734383 352.279703,20.5734383 C370.982829,20.5734383 385.256267,31.7953138 389.390642,49.218752 L411.342205,49.218752 C407.798455,20.2781258 383.582829,0 352.279703,0 C312.806264,0 288.295325,28.4484386 288.295325,74.5171905 C288.295325,120.487505 312.904701,148.935943 352.37814,148.935943 Z M451.232832,145.490631 L451.232832,98.8312539 L467.179708,81.0140657 L514.82346,145.490631 L542.385961,145.490631 L482.732833,65.1656276 L537.660961,3.44531264 L511.575022,3.44531264 L452.807832,69.9890653 L451.232832,69.9890653 L451.232832,3.44531264 L429.182831,3.44531264 L429.182831,145.490631 L451.232832,145.490631 Z" id="BRICK"></path>
                              <path d="M563.567485,146.250982 C567.369244,146.250982 570.142291,143.343756 570.142291,139.586724 C570.142291,135.829692 567.369244,132.922466 563.567485,132.922466 C559.810454,132.922466 556.99268,135.829692 556.99268,139.586724 C556.99268,143.343756 559.810454,146.250982 563.567485,146.250982 Z M596.083699,145.490631 L596.083699,120.891019 L610.217294,120.891019 L623.366905,145.490631 L634.951085,145.490631 L620.459678,119.236136 C628.331554,116.552542 632.983117,109.485745 632.983117,100.808791 C632.983117,88.6878914 624.619249,80.9501955 611.603818,80.9501955 L586.064948,80.9501955 L586.064948,145.490631 L596.083699,145.490631 Z M610.485654,112.348245 L596.083699,112.348245 L596.083699,89.761329 L610.217294,89.761329 C617.95499,89.761329 622.696006,94.0103528 622.696006,101.032424 C622.696006,108.233401 618.22335,112.348245 610.485654,112.348245 Z M657.269642,145.490631 L657.269642,80.9501955 L647.250891,80.9501955 L647.250891,145.490631 L657.269642,145.490631 Z M683.434683,145.490631 L683.434683,123.75352 L698.373357,123.75352 C711.030975,123.75352 719.976288,115.076566 719.976288,102.463674 C719.976288,89.6718759 711.299334,80.9501955 698.686443,80.9501955 L673.415933,80.9501955 L673.415933,145.490631 L683.434683,145.490631 Z M696.047575,114.942386 L683.434683,114.942386 L683.434683,89.8060556 L696.047575,89.8060556 C704.858709,89.8060556 709.733904,94.2787122 709.733904,102.463674 C709.733904,110.469729 704.679802,114.942386 696.047575,114.942386 Z" id=".RIP"></path>
                          </g>
                      </g>
                  </g>
              </svg>
              <p class="type-sm">Currently viewing a shared board</p>
          </div>
          <!-- <button class="button" on:click={login}>
              Log in to rip!
          </button> -->
          <Link to="/">
          <button class="button wide">
              Log in to rip!
          </button>
          </Link>
      </div>
  </div>
  <!-- <Profile {...user} on:change={changeBoard} bind:$boards={boards} on:get={setBoards} boardID={boardID} permissions="true" /> -->
  {#if boardID != '' && boardID != undefined}
  <Deck boardID={boardID} permissions="false" />
  {/if}

</section>

<style>
  .logout{
      position: absolute;
      top: 20px;
      right: 20px;
      background: #EFF0F2;
      color: #262728;
      border: none;
      padding: 8px 12px;
      border-radius: 10px;
  }
  .logout:hover{
      background: rgba(0, 0, 0, 0.963);
      color: #EFF0F2;
      cursor: pointer;
  }
  .fullscreen-signin{
      width: 100%;
      min-height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
  }
  .fullscreen-signin > *{
      margin: 10px;
  }
  .fullscreen-signin > button{
      background: rgba(0, 0, 0, 0.363);
      color: black;
      border: none;
      padding: 8px 12px;
      border-radius: 10px;
  }
  .fullscreen-signin > button:hover{
      background: rgba(0, 0, 0, 0.963);
      color: whitesmoke;
      cursor: pointer;
  }
  .fullscreen-signin>img{
      width: 30%;
      min-width: 400px;
  }
  @media(max-width: 770px){
      .fullscreen-signin>img{
          width: 60%;
      }
  }
  .flex{
      display:flex;
      justify-content: space-between;
  }
  /* .flex > button{
      background: rgba(0, 0, 0, 0.363);
      border: none;
      padding: 8px 12px;
      border-radius: 10px;
  }
  .flex > button:hover{
      background: rgba(0, 0, 0, 0.963);
      color: whitesmoke;
      cursor: pointer;
  } */

  .boardItems{
      padding: 1px;
      display: flex;
      flex-direction: column;
  }
  .boardItem{
      background-color: rgb(83, 158, 142);
      /* width: 100%; */
      border-radius: 8px;
      padding: 12px;
      /* margin-top: 1px; */
  }
  .minimalInput{
      border: none;
      background: transparent;
      color: white;
      font-size: 18px;
      line-height: 1;
  }
  .minimalInput::placeholder{
      color: white;
      font-size: 18px;
      line-height: 1;
  }
  .minimalInput:focus {outline:0;}

  .minimalButton{
      background: rgba(0, 0, 0, 0.363);
      color: whitesmoke;
      border: none;
      padding: 8px 12px;
      border-radius: 10px;
      cursor: pointer;
  }
  .minimalButton:hover{
      background: black;
      color: whitesmoke;
  }
  .logo{
  width: 80%;
  margin-bottom: 5px;
  transition: all 0.3s;
}

.small{
  width: 20%;
}
  .details{
      width: 100%;
  }
  .button{
  min-width: 100px;
  height: fit-content;
  margin-top: 6px;
  border: none;
  padding: 8px 12px;
  background: #EFF0F2;
  color: black;
  cursor: pointer;
  border-radius: 8px;
}
.button:hover{
  background: rgba(0, 0, 0, 0.963);
  color: white;
}
</style>
